// extracted by mini-css-extract-plugin
export var headline = "CardModule-module--headline--3t1dq";
export var centered = "CardModule-module--centered--2D0Z7";
export var cardsWrapper = "CardModule-module--cardsWrapper--3jiQn";
export var sectionContainerWhite = "CardModule-module--sectionContainerWhite--3F_HO";
export var sectionContainer = "CardModule-module--sectionContainer--2BLdS";
export var blueHeader = "CardModule-module--blueHeader--2feK_";
export var body = "CardModule-module--body--3Bdov";